module.exports = __webpack_public_path__ + "img/banner_left.1d2ed91d.png";